import { action } from '@reatom/framework'
import i18next from 'i18next'

import { Result } from '@blade/std-lib'
import { OAuthCode } from '@root/entities/auth'
import { reatomRequest } from '@root/shared/lib'
import { showSnackbarAction } from '@root/shared/ui-kit'

import { parseGoogleAuthAction } from '../model'

import { isUserExistsGoogleRequestAction } from './google-requests'
import { assignGoogleAction } from './reatom-google-assign'

import type { GoogleAuthAction } from '../model'
import type { TypeHelper } from '@blade/std-lib'
import type { GoogleAssignCreatePayload } from '@blade/trade-api-client'
import type { Deeplink } from '@root/entities/deeplinking'
import type { InviteCode } from '@root/entities/referral/model/referral-code'

export const handleGoogleAuthDeeplinkAction = action(
  async (ctx, deeplink: Deeplink.GoogleAuth) => {
    const code = deeplink.code ?? OAuthCode('')

    const parsedState = deeplink.state
      ? parseGoogleAuthAction(deeplink.state)
      : undefined

    if (parsedState?.action === 'assign') {
      assignGoogleAction(ctx, code)
      return
    }

    googleUserExistenceCheckStateAtom.execute(ctx, {
      googleAuthCode: code,
      referralCode: parsedState?.referralCode,
    })
  },
  'handleGoogleAuthDeeplinkAction',
)

export interface GoogleAuthData {
  code: OAuthCode
  action: GoogleAuthAction | undefined
  referralCode: InviteCode | undefined
}

export const googleUserExistenceCheckStateAtom = reatomRequest({
  execAction: isUserExistsGoogleRequestAction,
  // eslint-disable-next-line @reatom/unit-naming-rule
  name: 'googleUserExistenceCheckStateAtom',
  prepare: (
    _,
    args: GoogleAssignCreatePayload & {
      googleAuthCode: OAuthCode
      referralCode: InviteCode | undefined
    },
  ) => args,
  onResult: (ctx, result, [{ googleAuthCode, referralCode }]) => {
    if (Result.isSuccess(result)) {
      const code = googleAuthCode
      if (result.success.exists) {
        loginWithGoogleDeeplinkEvent(ctx, {
          code,
          action: 'login',
        })
      } else {
        registerWithGoogleDeeplinkEvent(ctx, {
          code,
          action: 'register',
          referralCode,
        })
      }
    } else {
      showSnackbarAction(ctx, {
        intent: 'error',
        text: i18next.t('auth.google-auth-error'),
        description: i18next.t('auth.google-auth-error-existence-check'),
      })
    }
  },
})

// eslint-disable-next-line @reatom/unit-naming-rule
export const loginWithGoogleDeeplinkEvent = action<
  TypeHelper.OmitKey<GoogleAuthData, 'referralCode'>
>('loginWithGoogleDeeplinkEvent')
// eslint-disable-next-line @reatom/unit-naming-rule
export const registerWithGoogleDeeplinkEvent = action<GoogleAuthData>(
  'registerWithGoogleDeeplinkEvent',
)
